/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type FuelType = typeof FuelType[keyof typeof FuelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FuelType = {
  Diesel: 'Diesel',
  DieselEuro6: 'DieselEuro6',
  Hybrid: 'Hybrid',
  Electric: 'Electric',
  Petrol: 'Petrol',
} as const;
